import type { IssueMode, IssueSeverity, IssueType } from '../types/issue';

export interface ResolveIssueModeInput {
  type: IssueType;
  severity: IssueSeverity;
  recurrenceDetected?: boolean;
  forceStructured?: boolean;
}

export function resolveIssueMode(input: ResolveIssueModeInput): IssueMode {
  if (input.forceStructured) return 'structured_problem';
  if (input.type === 'incident' && input.severity !== 'critical' && !input.recurrenceDetected) {
    return 'quick_correction';
  }
  if (input.type === 'non_conformity' || input.type === 'customer_complaint') {
    return 'structured_problem';
  }
  if (input.severity === 'critical' || input.recurrenceDetected) {
    return 'structured_problem';
  }
  return 'quick_correction';
}
